import { Button, CheckBox } from "@shltelemedicine/shl-ui-lib";
import { ReactNode, useState } from "react";
import { Col, Form } from "react-bootstrap";
import { FormattedMessage } from "react-intl";
import { v4 as uuidv4 } from "uuid";
import { useEcgDetailsContext } from "../../../../context/EcgDetailsContext";
import { ILead } from "../../../../models/ecg.interface";
import { arrayToChunks } from "../../../../utils/sharedUtil";
import NextPrevIcon from "../../../Shared/NextPrevIcon/NextPrevIcon";
import styles from "./Leads.module.css";

const numColumnsInLeads: number = 4;
type LeadsProps = {
  closeLeadsPane: () => void;
  title: ReactNode;
  findingKey: string;
};

const Leads = ({ closeLeadsPane, title, findingKey }: LeadsProps) => {
  const {
    state: { ecgEdit },
    actions: { edit },
  } = useEcgDetailsContext();

  const findingWithLeads = ecgEdit?.findings?.find((l) => l.key === findingKey);

  const [showSelectionCanceled, setShowSelectionCanceled] = useState(false);

  const backButtonHoverHandler = () => {
    const leads = findingWithLeads?.leads?.filter((l) => l.value);
    if (leads?.length) return;
    setShowSelectionCanceled(true);
  };
  const backButtonLeaveHandler = () => {
    setShowSelectionCanceled(false);
  };

  const handleCloseLeadsPane = () => {
    const leads = findingWithLeads?.leads?.filter((l) => l.value);
    if (!leads?.length) {
      const finding = ecgEdit?.findings?.find((f) => f.key === findingKey);

      if (!finding) return;

      finding.value = !finding.value;

      edit(ecgEdit!);
    }
    closeLeadsPane();
  };

  const onToggle = (event: React.ChangeEvent<HTMLInputElement>): void => {
    if (!ecgEdit?.findings || !ecgEdit.findings.length) return;

    const id = event.currentTarget.name;
    const lead = findingWithLeads?.leads!.find((l) => l.name === id);

    if (!lead) return;

    lead.value = !lead.value;

    edit(ecgEdit);
  };
  return (
    <>
      <header
        className={`${styles.header} p-sm-1 app-shadow d-flex justify-content-center align-items-center`}
      >
        <div className={`${styles.titleWrapper} d-flex align-items-center`}>
          <Button
            variant=""
            className="p-0"
            onClick={handleCloseLeadsPane}
            disabled={false}
            onMouseOver={backButtonHoverHandler}
            onMouseLeave={backButtonLeaveHandler}
          >
            <NextPrevIcon disabled={false} />
          </Button>
          <span className={styles.title}>{title}</span>
        </div>
        {showSelectionCanceled && (
          <div className={`${styles.cancelInfo}`}>
            <FormattedMessage
              id="ECG_DETAILS.LEADS.SELECTION_CANCELED"
              defaultMessage="Selection will be canceled"
            />
          </div>
        )}
      </header>
      <div className="overflow-auto">
        <div className={`${styles.form} mt-3`}>
          <Form>
            <Form.Row>
              {arrayToChunks(
                findingWithLeads?.leads ?? [],
                numColumnsInLeads
              ).map((LeadsChunck) => (
                <Col
                  xs={12 / numColumnsInLeads}
                  className="align-items-center font-md my-md-3"
                  key={uuidv4()}
                >
                  {LeadsChunck.map((lead: ILead) => (
                    <Form.Row key={lead.code.toString()} className="mb-2">
                      <CheckBox
                        name={lead.name}
                        label={lead.name}
                        checked={lead.value}
                        disabled={lead.disabled}
                        onChange={onToggle}
                      />
                    </Form.Row>
                  ))}
                </Col>
              ))}
            </Form.Row>
          </Form>
        </div>
      </div>
    </>
  );
};

export default Leads;
